import { SkeletonLoaderModule } from './../../shared/component/skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NotificationFilterPipe } from './pipe/notification-filter.pipe';

@NgModule({
    declarations: [NotificationComponent, NotificationFilterPipe],
    imports: [
        CommonModule,
        MatTooltipModule,
        MatBadgeModule,
        MatButtonToggleModule,
        ScrollingModule,
        SkeletonLoaderModule
    ],
    providers: [],
    exports: [NotificationComponent]
})
export class NotificationModule { }
